export const OPERATORS = {
    onOrAfter: 'onOrAfter',
    onOrBefore: 'onOrBefore',
    equals: 'equals',
    contains: 'contains',
};
